import React from 'react';

import './OrderSummarypageSkeleton.scss';

const SkeletonBlock = ({ width, height, count = 1, className = "" }) => (
  <>
    {Array.from({ length: count }).map((_, index) => (
      <span
        key={index}
        className={`orderSummarySkeletonBlock ${className}`}
        style={{ '--skeletonWidth': typeof width === 'number' ? `${width}px` : width, '--skeletonHeight': typeof height === 'number' ? `${height}px` : height }}
      />
    ))}
  </>
);

export default function OrderSummaryPageSkeleton() {
  return (
    <div className="OrderSummaryPageSkeletonWrapper">
      <div className="topBanner"><SkeletonBlock height={150} className="banner" /></div>

      <div className="cardSection"><SkeletonBlock width={300} height={36} /></div>

      <div className="title"><SkeletonBlock width={200} height={36} /></div>

      <div className="containerSection">
        <div className="flexBox">
          <SkeletonBlock width={10} height={400} />
          <div className="boxContainer">
            <div className="imageBox">
              <SkeletonBlock width={196} height={126} />
              <div className="image">
                <SkeletonBlock width={150} height={24} />
                <SkeletonBlock count={3} width={200} height={16} />
              </div>
            </div>
            <div className="boximage">
              <SkeletonBlock width={150} height={24} />
              <SkeletonBlock count={3} width={200} height={16} />
            </div>
            <div className="boximage">
              <SkeletonBlock width={150} height={24} />
              <SkeletonBlock count={3} width={200} height={16} />
            </div>
          </div>
        </div>

        <div className="cardContainer">
          <div className='margin_tb_8'>
            <div className="imageContainer">
              <SkeletonBlock width={150} height={24} />
              <div className="containerBox">
                <SkeletonBlock width={200} height={20} />
                <SkeletonBlock width={180} height={20} />
                <SkeletonBlock width={190} height={20} />
              </div>
              <SkeletonBlock width={250} height={24} />
              <SkeletonBlock width={200} height={20} />
            </div>
          </div>
        </div>
      </div>

      <div className="bottomSection">
        <SkeletonBlock width={300} height={20} className="bottom" />
        <div className="orderSummary">
          <SkeletonBlock width={100} height={20} />
          <SkeletonBlock width={120} height={20} />
          <SkeletonBlock width={140} height={20} />
        </div>
      </div>
    </div>
  );
};
